import { Locale } from "@/Common/Models/Localization/Locale";

interface IFormFieldRowProps {
    className?: string | null;
    labelValueKey?: string;
    value?: React.ReactNode;
    isEditMode?: boolean;
    style?: React.CSSProperties;
    hasParentClassName?: boolean;
    extraLabelElement?: React.ReactNode;
    isLabelUpperCase?: boolean;
    inline?: boolean;
    disableBoldLabel?: boolean;
    inlineSpaceBetween?: boolean;
    locale?: Locale;
    token?: object;
    valueStyle?: React.CSSProperties;
    required?: boolean;
    onReadOnlyClick?: React.MouseEventHandler;
}

class FormFieldRow extends React.Component<IFormFieldRowProps, never> {
    public render(): JSX.Element {
        const className = this.props.className ?? "col-md-12";
        const value = this.props.value;

        let styles: React.CSSProperties = {};
        let labelStyles: React.CSSProperties = {};
        let valueStyles: React.CSSProperties = {};

        if (this.props.inline) {
            styles = {
                display: "flex",
                justifyContent: this.props.inlineSpaceBetween ? "space-between" : "flex-start",
                alignItems: "center"
            };

            if (!this.props.required)
                labelStyles.marginRight = "10px";

            valueStyles.minHeight = "20px";
            valueStyles.marginBottom = "5px";
        }

        labelStyles.fontWeight = this.props.disableBoldLabel ? "normal" : "bold";
        valueStyles = { ...valueStyles, ...this.props.valueStyle };

        return (
            <div
                className={this.props.hasParentClassName ? "" : "row margin-sm-bottom"}
                style={this.props.style}
            >
                <div className={className} style={styles}>
                    {this.props.labelValueKey && (
                        <label
                            className={`"form-label ${(this.props.required ? "required-right" : "")}`}
                            style={labelStyles}
                        >
                            {!value && this.props.onReadOnlyClick
                                ? (
                                    <a
                                        onClick={(e: React.MouseEvent) => this.props.onReadOnlyClick?.(e)}
                                        className="min-height-value"
                                    >
                                        {cacheStore.GetString(this.props.labelValueKey, this.props.token, this.props.locale)}
                                    </a>
                                )
                                : cacheStore.GetString(this.props.labelValueKey, this.props.token, this.props.locale)
                            }

                        </label>
                    )}
                    {this.props.extraLabelElement}
                    {this.props.isEditMode
                        ? <div style={valueStyles}>{this.props.children}</div>
                        : ( // read-only mode
                            <div className="min-height-value" style={valueStyles}>
                                {this.props.onReadOnlyClick
                                    ? (
                                        <a
                                            onClick={(e: React.MouseEvent) => this.props.onReadOnlyClick?.(e)}
                                            className="min-height-value"
                                            style={valueStyles}
                                        >
                                            {value}
                                        </a>
                                    )
                                    : value
                                }
                            </div>
                        )
                    }
                </div>
            </div>
        );
    }
}

export { FormFieldRow, IFormFieldRowProps };
